import { cloneDeep } from 'lodash'

const initialState = () => ({
  totalRows: 0,
  rowsSelected: [],
  selectAll: false,
  vendors: null,
  owners: null,
  tableState: {
    filter: null,
    chipFilter: null,
    columns: null
  }
})

export default {
  namespaced: true,

  state: initialState(),

  getters: {
    numberOfSelectedRows(state) {
      if (state.selectAll) {
        return state.totalRows - state.rowsSelected.length
      }
      return state.rowsSelected.length
    }
  },

  mutations: {
    setTotalRows: (state, payload) => (state.totalRows = payload),
    setRowsSelected: (state, payload) => (state.rowsSelected = payload),
    setSelectAll: (state, payload) => (state.selectAll = payload),
    setVendors: (state, payload) => (state.vendors = payload),
    setOwners: (state, payload) => (state.owners = payload),
    setTableState: (state, payload) => (state.tableState = payload),
    setTableStateFilter: (state, payload) => (state.tableState.filter = payload),
    setTableStateChipFilter: (state, payload) => (state.tableState.chipFilter = payload),
    setTableStateColumns: (state, payload) => (state.tableState.columns = payload),
    changeChipFilters: (state, chipFilter) => {
      let filters = [...state.tableState.chipFilter]
      if (filters.includes(chipFilter)) filters = filters.filter(f => f !== chipFilter)
      else filters.push(chipFilter)

      state.tableState.chipFilter = filters
    },
    resetState: state => Object.assign(state, initialState())
  },

  actions: {
    setDefaultTableState({ commit, rootState }) {
      const viewModeTableState = rootState['lv-subscriptions'].tableState
      commit('setTableState', cloneDeep(viewModeTableState))
    }
  }
}
